// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Loading_spinnerContainer__vqNZ2","spinner":"Loading_spinner__VwMOh","spin":"Loading_spin__hXaDT"};